import { getAllAddress, getIfFresh, getIndustries, getPosions, getProfessional } from '@/api/request/commonService'
import { PgetProfessional, PPositionTypes } from '@/api/request/homePageService'
import WebIM from './WebIM'
import store from '@/store'
import WebIMConfig from '@/utils/WebIMConfig'
import Viewer from 'viewerjs'

/**
 * @author lihh
 * @description 进行图片预览
 * @type {{install(*)}}
 */
export const PreviewImage = (() => {
  return {
    install(Vue) {
      Vue.prototype.$Viewer = function(selector, options) {
        if ( typeof selector === 'undefined' ) return
        if ( typeof options === 'undefined' ) options = {}
        return new Viewer(selector, { title: false, ...options })
      }
    }
  }
})()

const execFunArr = [
  { localKey: 'getAllAddress', fun: getAllAddress },
  { localKey: 'getPosions', fun: getPosions },
  { localKey: 'PgetProfessional', fun: PgetProfessional },
  { localKey: 'PPositionTypes', fun: PPositionTypes },
  { localKey: 'getIndustries', fun: getIndustries },
  { localKey: 'getProfessional', fun: getProfessional }
]
/* 判断是否运行状态 */
export const runPedding = { flag: false }
/* 定时器载体 */
let timer = null
/* 单例模式 */
export const singleCase = {}
/* uuid随机数 */
import { v4 } from 'uuid'
import { Message } from 'view-design'
import { getMsgNoReadNum, ifRecall } from '@/api/request/concatService'

/**
 * @author lihh
 * @description 表示特殊的常量符号
 * */
export const NOMAL_SYMBOL = {
  messsage: '###@@@',
  clear: '###$$$'
}

const sessionTypes = [ 'getAllAddress', 'getProfessional', 'getIndustries', 'getPosions', 'PgetProfessional', 'PPositionTypes' ]

/**
 * @author lihh
 * @desc 根据本地的code值 判断数据是否更新 更新后重新覆盖本地数据 返回给调用者本地最新的数据
 * @param key 要返回一个数组
 * @param funArr 回调的方法数组
 */
export function querySessionUpdate(key, funArr, sessionKey = 'hpc_local_session_code') {
  return new Promise(async (resolve) => {
    /* 查看缓存是否存在 进行数据请求 */
    if ( !sessionTypes.includes(key) ) {
      throw TypeError(`缓存类型不对，key必须是${ sessionTypes.join('|') }中的某一个`)
    }
    if ( !Array.isArray(funArr) ) funArr = execFunArr
    if ( runPedding.flag ) {
      await new Promise((resolves) => {
        let timer = setInterval(() => {
          if ( !runPedding.flag ) {
            clearInterval(timer)
            resolves()
          }
        }, 10)
      })
    }
    runPedding.flag = true

    /* 进行数据请求 */
    getIfFresh().then(res => {
      if ( res.code !== '200' ) {
        console.log('数据刷新失败了')
        resolve(key)
        runPedding.flag = false
        return
      }
      // 判断缓存code是否发生过变化
      const sessionCode = localStorage.getItem(sessionKey) || ''
      if ( res.data === sessionCode ) {
        resolve(key)
        runPedding.flag = false
        return
      }

      /* 进行数据请求 */
      let index = 0
      const len = funArr.length
      funArr.forEach(({ localKey, fun }) => {
        fun().then((res1) => {
          if ( res1.code === '200' ) {
            index ++
            // 缓存本地数据
            localStorage.setItem(localKey, JSON.stringify(res1.data))
            if ( index >= len ) {
              runPedding.flag = false
              localStorage.setItem(sessionKey, res.data)
              resolve(key)
            }
          }
        })
      })
    })
  }).then(localKey => {
    /* 开始获取本地信息 */
    let localHpcInfo = localStorage.getItem(localKey) || ''
    localHpcInfo = localHpcInfo ? JSON.parse(localHpcInfo) : {}
    return Promise.resolve({
      code: '200',
      data: localHpcInfo
    })
  })
}

/**
 *
 * @author lihh
 * @description 表示时间戳的共同的处理
 * @param ptime 表示传递时间戳
 * @return {{hours: number, minutes: number, padNum: (function(*, *=, *=): string), timeMaptting: {"1": string, "2":
 *     string}, surDay: number}}
 */
const commonTimes = ptime => {

  const padNum = (time, len = 2, val = '0') => (time + '').padStart(len, val),
    timeYmdHandle = time => {
      const strDate = new Date(typeof time === 'string' ? + time : time),
        year = strDate.getFullYear(),
        month = padNum(strDate.getMonth() + 1),
        day = padNum(strDate.getDate())
      return + new Date(`${ year }/${ month }/${ day } 00:00:00`)
    }
  const timeMaptting = {
    '1': '昨天',
    '2': '前天'
  }
  const paramTime = new Date(typeof ptime == 'string' ? + ptime : ptime),
    hours = paramTime.getHours(),
    minutes = paramTime.getMinutes(),
    diff = (timeYmdHandle(+ new Date()) - timeYmdHandle(ptime)) / 86400000,
    surDay = Math.floor(diff)
  return {
    timeMaptting,
    hours,
    minutes,
    padNum,
    surDay
  }
}

/**
 * @author lihh
 * @description 表示用户列表显示时间的方法
 * @param ptime 表示传递的时间
 * @return {string|*}
 */
export function timesChange(ptime) {
  const { timeMaptting, hours, minutes, padNum, surDay } = commonTimes(ptime)
  if ( surDay >= 1 ) {
    return timeMaptting[surDay + ''] ? timeMaptting[surDay + ''] : `${ surDay }天前`
  }
  return `${ padNum(hours) }:${ padNum(minutes) }`
}

/**
 * @author lihh
 * @description 显示详细的时间变换 (用来聊天内显示的)
 * @param ptime 表示时间戳
 */
export function detailedTimesChange(ptime) {
  const { timeMaptting, hours, minutes, padNum, surDay } = commonTimes(ptime)
  if ( + surDay <= 0 ) {
    return `${ padNum(hours) }:${ padNum(minutes) }`
  }
  if ( timeMaptting[+ surDay] ) {
    return `${ timeMaptting[+ surDay] } ${ padNum(hours) }:${ padNum(minutes) }`
  }
  return `${ surDay }天前`
}

/**
 * @author lihh
 * @description 简单的防抖策略
 * @param func 表示需要运行函数
 * @param time 延迟时间
 * @param fastFlag 是否立即触发
 */
/* 是否已经执行结束 */
let execd = false

export function simpleDebounce(func, time = 500, fastFlag = false) {
  /* 满足条件说明未到执行时间 */
  if ( timer ) {
    clearTimeout(timer)
    timer = null
  }

  /* 表示延迟执行 */
  timer = setTimeout(() => {
    if ( !fastFlag ) func()
    clearTimeout(timer)
    timer = null
    execd = false
  }, time)
  if ( fastFlag && !execd ) {
    func()
    execd = true
  }
}

/**
 * @author lihh
 * @description 用来获取随机数
 * @return {*}
 */
export const randomVal = () => v4()

/**
 * @author lihh
 * @description 进行统一的订阅消息通知
 * @param keyName 订阅名称
 * @param randomParam 以及传递参数
 * @param replaceFlag 是否替换 如果是true的场合 参数直接替换随机数
 */
export const subscribeMsgNotice = (keyName, randomParam, replaceFlag = false) => {
  /* 参数拼接 */
  let param = randomParam ? `${ randomVal() }_${ randomParam }` : v4()
  if ( replaceFlag ) param = randomParam
  if ( singleCase.__watcher__ ) singleCase.__watcher__[keyName] = param
}

/**
 * @author lihh
 * @description 表示hr回复问答 消息通知
 * @param groupName 表示群名称
 * @param groupId 表示群名称
 */
export const hrReplyMsgNotice = (groupId, groupName) => {
  Message.success(`您在群【${ groupName }】消息回复了,快去查看吧.`)
  subscribeMsgNotice('hrQuestion_callback', groupId)
}

/**
 * @author lihh
 * @description 将环信的消息 都设置为已读
 * @param to 表示谁的会话
 * @param type 表示群聊group 单聊contact
 */
export const updateMsgReadStatus = (to, type) => {
  /* 判断这个人是否我的列表中 */
  const flag = type === 'contact',
    keyName = flag ? 'name' : 'groupId',
    userList = store.getters[flag ? 'onGetContactUserList' : 'onGetGroupUserList'] || [],
    existFlag = userList.some(item => item[keyName] === to)
    // console.log('existFlag',existFlag)
  if ( !existFlag ) return
  /* 设置整体会话已读 */
  const msgBody = new WebIM.message('channel', WebIM.conn.getUniqueId()),
    options = { to }
  if ( type !== 'contact' ) options['chatType'] = 'groupChat'
  msgBody.set(options)
  WebIM.conn.send(msgBody.body)

  /* 清空本地的已读状态 */
  store.commit('updateMessageStatus', { name: type, action: 'oneUserReadMsgs', readUser: to, self: false })
}

/**
 * @author lihh
 * @description 判断页面是否刷新主要为了环信登录
 * @param callback 表示继续调用的方法
 */
export const isRefresh = (callback) => {
  if ( typeof callback !== 'function' ) callback = Function.prototype
  const hxLoading = sessionStorage.getItem('hx_loading')
  if ( !hxLoading ) {
    callback()
    return
  }

  let bigTimer = null, smallTimer = null
  bigTimer = setTimeout(() => {
    callback()
    clearTimeout(bigTimer)
  }, 2000)
  smallTimer = setInterval(() => {
    const hxLoading = sessionStorage.getItem('hx_loading')
    if ( !hxLoading ) {
      clearTimeout(bigTimer)
      clearInterval(smallTimer)
      callback()
    }
    console.log('登录中...')
  }, 10)
}

/**
 * @author lihh
 * @description 更新用户保存未读消息记录
 * @param id 表示对方的id
 * @param flag 判断是添加 还是 删除 + -
 * @param num 表示数字
 */
export const updateUserUnreadMsgRecords = (id, num) => {
  if ( !+ num || + num === - 1 ) return
  if ( !singleCase['__unreadRecords__'] ) singleCase['__unreadRecords__'] = {}
  singleCase['__unreadRecords__'][id] = num
}
/**
 * @author lihh
 * @description 获取用户未读历史记录
 * @param id 表示用户id
 * @return {*} true 有未读 false 没有未读
 */
export const getUserUnreadRecords = id => singleCase['__unreadRecords__'] && singleCase['__unreadRecords__'][id]

/**
 * @author lihh
 * @description 计算消息未读个数
 * @param options id 表示id 用户id / 群id
 */
export const mixinMsgUnreadNum = async (options) => {
  const { id = '' } = options || {}
  const res = await getMsgNoReadNum(id)
  if ( res.code !== '200' ) {
    Message.error(res.msg)
    return
  }
  /* 如果结果是null场合 环信为空 */
  if ( typeof res.data !== 'number' ) return - 1
  return + res.data
}

/**
 * @author lihh
 * @description 设置内容的高度 以1680 * 1050为基准
 * @param height 计算的高度
 * @return 返回具体的高度值 int
 */
export const mixinDispalyH = (height) => {
  if ( typeof height !== 'number' && !Array.isArray(height) ) return height
  height = Array.isArray(height) ? height : [ height ]
  const sum = height.length === 1 ? height[0] : height.reduce((pre, cur) => pre + cur, 0),
    h = document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight
  return h - 30 - sum
}

/* 表示未计算到消息的langType */
export const notComputedToMsgNumberLangType = [ '6']

/**
 * @author lihh
 * @description 将组件的消息做中间件 底层调用原生组件 如果遇到特殊的情况 直接不报错误
 */
export const mixinMessage = (() => {
  const keys = Object.keys(Message),
    excludeMsg = [ 'Token已失效', '', '传参方式错误，或有必填项未填写，请检查必填项', '网络错误' ],
    messageObj = {}
  keys.forEach(method => {
    messageObj[method] = function(message) {
      if ( excludeMsg.includes(message) ) return false
      Message[method](message)
    }
  })
  return messageObj
})()

/**
 * @author lihh
 * @description 判断消息是否撤回
 * @param mid
 */
const requestMid = []
let timerMid = null
export const settingMsgRecallStatus = mid => {
  if ( !mid ) return
  /* 为了避免重复请求过多 */
  if ( !timerMid ) {
    timerMid = setTimeout(() => {
      requestMid.length = []
      clearTimeout(timerMid)
      timerMid = null
    }, 1000)
  }
  if ( requestMid.includes(mid) ) return
  requestMid.push(mid)

  let recallMsgInfo = localStorage.getItem('recall_info')
  /* 共同请求数据方法 */
  const commonRequest = () => {
    return new Promise((resolve, reject) => {
      ifRecall(mid).then(res => {
        if ( res.code !== '200' ) {
          reject(false)
          return
        }
        resolve(res.data)
      })
    })
  }
  /* 表示撤回后的逻辑 */
  const recallMsgAfter = () => {
    recallMsgInfo = !recallMsgInfo ? [ mid ] : Array.isArray(recallMsgInfo) ? recallMsgInfo.concat([ mid ]) : recallMsgInfo + `,${ mid }`
    localStorage.setItem('recall_info', recallMsgInfo)
    store.commit('updateMessageStatus', { isRecall: true, mid })
  }
  if ( !recallMsgInfo ) {
    commonRequest().then(val => {
      /* 0 表示未撤回 1 已撤回 */
      if ( val === 0 ) return
      recallMsgAfter()
    })
    return
  }
  recallMsgInfo = recallMsgInfo.split(',')
  if ( recallMsgInfo.includes(mid) ) {
    store.commit('updateMessageStatus', { isRecall: true, mid })
    return
  }
  commonRequest().then(val => {
    /* 0 表示未撤回 1 已撤回 */
    if ( val === 0 ) return
    recallMsgAfter()
  })
}

/**
 * @author lihh
 * @description 设置常用语默认变量
 */
// eslint-disable-next-line no-undef
singleCase.__commonWords__ = (() => Object.values(JSON.parse(commonWords)))()

/**
 * @author lihh
 * @description 获取环信的会话记录(包括用户未读数等)
 * @returns {Promise<*[]>}
 */
export const getSessionList = async () => {

  /* 生成对象 */
  const createObj = (id, type, time, unread_num) => ({
    id,
    type,
    time,
    unread_num
  })

  /* 名称拆分规则 */
  const nameSplitHandle = id => {
    const splitFlags = WebIMConfig.appkey.split('#')[1]
    const matchArr = id.match(new RegExp(`#${splitFlags}_([0-9]+)@`))
    if ( !Array.isArray(matchArr) ) return
    if ( matchArr.length > 0 ) return matchArr[1]
    const idArr = id.split('@')[0].split(`#${splitFlags}_`)
    id = idArr[idArr.length - 1]
    return id
  }

  const result = await WebIM.conn.getSessionList(),
    { data: { channel_infos } } = result
  let i = 0,
    sortBefore = [],
    sortAfter = []
  for ( ; i < channel_infos.length; i ++ ) {
    const { channel_id, unread_num, meta: { timestamp: time } } = channel_infos[i],
      type = channel_id.indexOf('@conference.easemob.com') === - 1 ? 1 : 2,
      id = nameSplitHandle(channel_id)
    sortBefore.push(createObj(id, type, time, unread_num))
  }

  /* 进行排序 */
  sortAfter = sortBefore.sort((before, after) => after.time - before.time)
  return sortAfter
}

/**
 * @author lihh
 * @description 将环信的数据 以及后端查询的数据进行整合
 * @param sessionList 表示环信的消息session
 * @param userInfo 表示用户信息
 * @param keyName 表示比较的主键字段
 * @param type 表示单聊还是群聊
 */
export const userInfoSessionListCompare = (sessionList, userInfo, keyName = 'userName', type = 1) => {
  sessionList = sessionList.filter(item => item.type === type)
  userInfo = JSON.parse(JSON.stringify(userInfo))
  let newUserInfo = [],
    ids = sessionList.map(item => item.id),
    i = 0,
    localIndex = - 1

  for ( ; i < ids.length; i ++ ) {
    localIndex = userInfo.findIndex(item => item[keyName] === ids[i])
    if ( localIndex === - 1 ) continue
    newUserInfo.push({
      ...userInfo.splice(localIndex, 1)[0],
      unreadNum: sessionList[i]['unread_num']
    })
  }

  userInfo.forEach(item => newUserInfo.push({ ...item, unreadNum: 0 }))
  return keyName === 'userName' ? chatInfoDispatchHandle('singleChatNoapproSort', newUserInfo) : newUserInfo
}

/**
 * @author lihh
 * @description 聊天信息的调度处理
 * @param type 表示调度类型
 * @param list 表示需要调用信息
 */
const chatInfoDispatchHandle = (type, list) => {
  const dispatchObj = {
    singleChatNoapproSort: list => singleChatNoapproSort(list)
  }
  if ( !Reflect.ownKeys(dispatchObj).includes(type) ) return
  return dispatchObj[type](list)
}

/**
 * @author lihh
 * @description 表示单聊不合适排序
 * @param list 表示排序信息
 */
const singleChatNoapproSort = list => {
  // 单独筛选不合适
  const noTarget = []
  list.forEach(item => {
    if ( item.isInterest === 2 ) noTarget.push(item)
  })
  // 如果没有不合适 直接返回原数组
  if ( noTarget.length === 0 ) return list
  // 反之 非不合适内容 && 不合适内容
  return list.filter(item => item.isInterest !== 2).concat(noTarget)
}



// WEBPACK FOOTER //
// ./src/utils/tool.js